import { addImposterToUrl } from 'Utils';
import { api } from '../axios';
import { SUPPLIERS_ID } from 'Enum/suppliers';

export interface ISuppliersResult {
  id: string;
  status: number;
  name: string;
  gender: number;
  degree: number;
  hasPrivateParking: boolean;
  hasPublicParking: boolean;
  hasHomeVisit: boolean;
  region: number;
  email: string;
  firstStreet: string;
  firstHouseNumber: string;
  firstApartmentNumber: string;
  firstEntrance: string;
  firstNeighborhood: string;
  firstCityId?: number;
  firstZipCode: string;
  firstPostOffice: string;
  firstCountry: string;
  secondStreet: string;
  secondHouseNumber: string;
  secondApartmentNumber: string;
  secondEntrance: string;
  secondNeighborhood: string;
  secondCityId?: number;
  secondZipCode: string;
  secondPostOffice: string;
  secondCountry: string;
  cellPhonePrefix: string;
  cellPhoneNumber: string;
  homePhonePrefix: string;
  homePhoneNumber: string;
  hasAccessibilityForHandicapped: boolean;
  academicDegreeId?: number;
  academicDegree: string;
  professions: number[];
  languages: number[];
  regions: number[];
  areas: number[];
  area: number;
  specialties: number[];
  prefixes: number[];
  firstLongitude?: number;
  firstLatitude?: number;
  secondLongitude?: number;
  secondLatitude?: number;
  treatmentMethods: number[];
  expertises: number[];
  instituteId: string;
  instituteName: string;
}

export interface ISuppliersResource {
  resourceId: number;
  content: string;
}

export interface ISuppliersResourceCategory {
  [key: string]: {
    categoryName: string;
    resources: ISuppliersResource[];
  };
}

export interface ISingleResource {
  categoryCode: string;
  categoryName: string;
  resources: ISuppliersResource[];
}

const getSuppliersAPI = (supplierType: number) => {
  switch (supplierType) {
    default:
    case SUPPLIERS_ID.mentalTherapy:
      return { category: 'mental', queryName: 'profession' };
    case SUPPLIERS_ID.doctors:
      return { category: 'doctors', queryName: 'specialty' };
  }
};

export const getSuppliers = async (
  supplierType: number,
  specialtyId: number,
  supplierId?: string
) => {
  const supplierAPI = getSuppliersAPI(supplierType);
  const suppliers = await api.get<ISuppliersResult[]>(
    addImposterToUrl(
      `/Suppliers/${supplierAPI.category}?${
        supplierAPI.queryName
      }=${specialtyId}${supplierId ? `&id=${supplierId}` : ''}`,
      true
    )
  );
  if (suppliers?.data) return suppliers.data;
};

export const getSupplierResources = async (specialtyCode: number) => {
  const supplierAPI = getSuppliersAPI(specialtyCode);
  const resources = await api.get<ISuppliersResourceCategory>(
    addImposterToUrl(
      `/SupplierResources/${supplierAPI.category}?supplierType=${specialtyCode}`,
      true
    )
  );
  if (resources?.data) return resources.data;
};

export const getSupplierNames = async (specialtyCode: number) => {
  const suppliers = await api.get<string[]>(
    addImposterToUrl(
      `/Suppliers/suppliersNames?therapistType=${specialtyCode}`,
      true
    )
  );
  if (suppliers?.data) return [...new Set(suppliers.data)];
};

export const getDoctorSupplierNames = async (specialtyCode: number) => {
  const suppliers = await api.get<string[]>(
    addImposterToUrl(
      `/Suppliers/DoctorsSuppliersNames?therapistType=${specialtyCode}`,
      true
    )
  );
  if (suppliers?.data) return [...new Set(suppliers.data)];
};

export const getExpertise = async (specialtyCode: number) => {
  const suppliers = await api.get<ISingleResource>(
    addImposterToUrl(
      `/SupplierResources/expertises?therapistType=${specialtyCode}`,
      true
    )
  );
  if (suppliers?.data) return suppliers.data;
};

export const getTreatmentMethods = async (specialtyCode: number) => {
  const suppliers = await api.get<ISingleResource>(
    addImposterToUrl(
      `/SupplierResources/TreatmentMethods?therapistType=${specialtyCode}`,
      true
    )
  );
  if (suppliers?.data) return suppliers.data;
};
